<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span style="color: #fff">楼号：</span>
        <el-select v-model="buildId" :size="size" clearable placeholder="请选择楼号" @change="changeFloorNum">
          <el-option
            v-for="item in buildingData"
            :key="item.buildId"
            :label="item.buildNum"
            :value="item.buildId">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span style="color: #fff">楼层：</span>
        <el-select v-model="floorNum" :size="size" clearable placeholder="请选择楼层">
          <el-option
            v-for="item in floorNumData"
            :key="item.floorNum"
            :label="item.floorNum"
            :value="item.floorNum">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" @click="searchDormitoryList(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dormitoryList"
        height="100%" >
        <el-table-column label="序号" width="60" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="buildNum" label="楼号" align="center"></el-table-column>
        <el-table-column prop="floorNum" label="楼层" align="center"></el-table-column>
        <el-table-column prop="dormNum" label="房号" align="center"></el-table-column>
        <el-table-column prop="bedNum" label="床位数" align="center"></el-table-column>
        <el-table-column prop="dormUserCount" label="入住人数" align="center"></el-table-column>
        <el-table-column prop="dormAdminName" label="宿舍长" align="center"></el-table-column>
        <!-- <el-table-column prop="posDesc" label="检查记录" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propInspection(row)">查看</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="exportViewCode(row)">导出二维码</el-button>
            <!-- <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 修改宿舍信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增宿舍' : '修改宿舍信息'"
      :visible.sync="asyncDormitory"
      width="40%">
      <el-form ref="form" :model="formDormitory" :rules="rulesDormitory" label-width="auto" class="rule_form">
        <el-form-item label="楼号：" prop="buildId">
          <el-select v-model="formDormitory.buildId" :size="size" clearable placeholder="请选择楼号" @change="changeBuildData">
            <el-option
              v-for="item in buildingData"
              :key="item.buildId"
              :label="item.buildNum"
              :value="item.buildId">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="单元号：" prop="buildUnit">
          <el-input v-model="formDormitory.buildUnit" :size="size" clearable placeholder="请输入单元号"></el-input>
        </el-form-item> -->
        <el-form-item label="楼层：" prop="floorNum">
          <el-select v-model="formDormitory.floorNum" :size="size" clearable placeholder="请选择楼层" @change="changeFloorData">
            <el-option
              v-for="item in floorData"
              :key="item.floorNum"
              :label="item.floorNum"
              :value="item.floorNum">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房号：" prop="roomId">
          <el-select v-model="formDormitory.roomId" :size="size" clearable placeholder="请选择楼层">
            <el-option
              v-for="item in roomData"
              :key="item.roomId"
              :label="item.dormNum"
              :value="item.roomId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍长：">
          <el-select v-model="formDormitory.dormAdmin" :size="size" filterable clearable placeholder="请选择宿舍长">
            <el-option
              v-for="item in staffData"
              :key="item.userId"
              :label="item.realName"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="床位数：" prop="bedNum">
          <el-input v-model="formDormitory.bedNum" :size="size" clearable placeholder="请输入床位数"></el-input>
        </el-form-item>
        <el-form-item label="入住员工：">
          <el-transfer
            filterable
            filter-placeholder="请输入员工姓名"
            v-model="formDormitory.userIds"
            :titles="['未入住', '已入住']"
            :data="staffData"
            :props="{
              key: 'userId',
              label: 'realName'
            }">
          </el-transfer>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncDormitory = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 检查记录 -->
    <el-dialog
      class="prop_dialog"
      title="检查记录"
      :visible.sync="asyncInspection"
      width="35%">
      <div class="inspection_content">
        <div class="inspection_content_item" v-for="item in 4" :key="item.id">
          <div class="inspection_content_item--header">
            <span class="label">检查人：李明唐</span>
            <span>2023-02-12 09:09:09</span>
          </div>
          <div class="inspection_content_item--content">
            <span class="label">检查结果：测试结果</span>
            <div class="info_image" @click="asyncImage = true">
              <img :src="imgs" width="100%" height="100%">
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 查看图片 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncImageTitle ? '查看图片' : '查看二维码'"
      :visible.sync="asyncImage"
      width="35%">
      <div class="prop_image">
        <img :src="imageUrl" width="100%" height="100%">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imgs from '../../assets/404_images/image.jpg';
import { changeSize, throttle } from '../../plugins/public';
import { buttonPinia } from '../../pinia/index';
  export default {
    data() {
      return {
        imgs: imgs,
        buildId: '',
        buildingData: [],
        floorNum: '',
        floorNumData: [],
        size: changeSize(),
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        dormitoryList: [], // 宿舍列表信息
        asyncTitle: true, // true 添加信息   false 修改
        asyncDormitory: false, // 弹窗
        formDormitory: {}, // 表单信息
        rulesDormitory: {
          buildId: [{
            required: true,
            message: '请选择楼号',
            trigger: ['blur', 'change']
          }],
          floorNum: [{
            required: true,
            message: '请选择楼层',
            trigger: ['blur', 'change']
          }],
          roomId: [{
            required: true,
            message: '请选择房间号',
            trigger: ['blur', 'change']
          }],
          bedNum: [{
            required: true,
            message: '请输入床位数',
            trigger: 'blur'
          }]
        }, //校验规则
        floorData: [], // 楼层信息
        roomData: [], // 房间号信息
        staffData: [], // 宿舍长信息
        asyncInspection: false, // 检查记录
        asyncImageTitle: true, // true 查看图片  false  查看二维码
        asyncImage: false,
        imageUrl: imgs
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.getAllBuildData();
      that.searchDormitoryList(true);
    },
    methods: {
      // 获取全部楼号信息
      async getAllBuildData() {
        const { data } = await this.$api.Basics.GETALLBUILDDATA();
        this.buildingData = data;
      },
      // 获取所有人员信息
      async getAllStaffData(dormId) {
        this.staffData = [];
        const { data } = await this.$api.Personnerl.GETFORDORMSTAFFALLDATA({
          dormId: dormId
        });
        this.staffData = data;
      },
      // 查询宿舍列表信息
      searchDormitoryList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.dormitoryList = [];
        this.$api.Personnerl.SEARCHDORMITORYLIST({
          buildId: this.buildId,
          floorNum: this.floorNum,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.dormitoryList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncDormitory = true;
        this.getAllStaffData();
      },
      // 查看检查记录
      propInspection() {
        this.imageUrl = imgs;
        this.asyncImageTitle = true;
        this.asyncInspection = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncDormitory = true;
        this.getAllStaffData(row.dormId);
        this.$api.Personnerl.GETDORMITORYINFO({
          dormId: row.dormId
        }).then((res) => {
          const data = res.data.dormUserVoList.map(item => item.userId);
          const floorData = this.buildingData.find(item => item.buildId === res.data.buildId);
          this.floorData = floorData.floors;
          const roomData = this.floorData.find(item => item.floorNum == res.data.floorNum);
          this.roomData = roomData.roomList;
          this.$set(this.formDormitory, 'dormId', row.dormId);
          this.$set(this.formDormitory, 'buildId', res.data.buildId);
          this.$set(this.formDormitory, 'floorNum', res.data.floorNum);
          this.$set(this.formDormitory, 'roomId', res.data.roomId);
          this.$set(this.formDormitory, 'bedNum', res.data.bedNum);
          this.$set(this.formDormitory, 'dormAdmin', res.data.dormAdmin);
          this.$set(this.formDormitory, 'userIds', data);
        })
      },
      // 导出二维码
      exportViewCode(row) {
        const baseUrl = process.env.VUE_APP_BASE_URL;
        this.$api.System.GETEXPORTTOKENDATA({
          dormId: row.dormId,
        }).then((res) => {
          if(res.success) {
            this.asyncImageTitle = false;
            this.asyncImage = true;
            this.imageUrl = `${baseUrl}/htapi/staff/dorm/viewcode?authcode=${res.data}`
          }
        })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDormitory);
            params.userIds = params.userIds ? params.userIds.join(',') : '';
            this.$api.Personnerl.INSERTDORMITORYINFO(params).then((res) => {
              if(res.success) {
                this.asyncDormitory = false;
                this.searchDormitoryList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDormitory);
            params.userIds = params.userIds ? params.userIds.join(',') : '';
            this.$api.Personnerl.UPDATEDORMITORYINFO(params).then((res) => {
              if(res.success) {
                this.asyncDormitory = false;
                this.searchDormitoryList(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 根据选择的楼号获取楼层信息 
      changeBuildData(value) {
        this.floorData = [];
        if(this.formDormitory.floorNum) {
          this.$set(this.formDormitory, 'floorNum', '');
        } else if(this.formDormitory.roomId) {
          this.$set(this.formDormitory, 'roomId', '');
        }
        if(value) {
          const data = this.buildingData.find(item => item.buildId === value);
          this.floorData = data.floors;
        }
      },
      // 根据选择的楼层获取房间号信息
      changeFloorData(value) {
        this.roomData = [];
        if(this.formDormitory.roomId) {
          this.$set(this.formDormitory, 'roomId', '');
        }
        if(value) {
          const data = this.floorData.find(item => item.floorNum === value);
          this.roomData = data.roomList;
        }
      },
      // 根据选择的楼号获取楼层信息
      changeFloorNum(value) {
        this.floorNum = '';
        this.floorNumData = [];
        if(value) {
          const data = this.buildingData.find(item => item.buildId === value);
          this.floorNumData = data.floors;
        }
      },
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchDormitoryList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchDormitoryList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
    watch: {
      asyncDormitory(bol) {
        if(!bol) {
          this.formDormitory = {};
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>